import React, { MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import "../../assets/stylesheets/SkipLink.scss";

const SkipLink = (): React.JSX.Element => {
  const { t } = useTranslation();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    const main = document.querySelector<HTMLElement>("main");
    if (!main) return;

    event.preventDefault();
    if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");
    main.focus({ preventScroll: true });
    main.scrollIntoView({ block: "start" });
  };

  return (
    <a className="skip-link" href="#main" onClick={handleClick}>
      {t("skipLink.mainContent")}
    </a>
  );
};

export default SkipLink;
